import { PDFDownloadLink } from '@react-pdf/renderer';
import { Alert, Button } from "react-bootstrap";
import CampaignDocument from './campaign-document';
import { IMicrositeCampaign } from '@nkr/models/microsites';
import { useState } from 'react';

interface IProps {
    campaign: IMicrositeCampaign
    data: any[]
}

const LetterGenerator = ({ campaign, data }: IProps) => {
    const [loadLetter, setLoadLetter] = useState<boolean>(false);

    return (<>
        {!loadLetter && <Button bsStyle={'warning'} style={{ marginRight: 10 }} onClick={() => setLoadLetter(true)} >{'Generate Template File'}</Button>}

        {loadLetter &&
            <PDFDownloadLink
                fileName={`${campaign?.campaignName}.pdf`}
                document={<CampaignDocument campaign={campaign} data={data} />}
            >
                {
                    ({ blob, url, loading, error }) => {
                        return (
                            <>
                                {(!url && !error) && <Button bsStyle={'warning'} style={{ marginRight: 10 }} disabled>Generating ...</Button>}
                                {error && <Alert>Error {error.message}</Alert>}
                                {url && <Button bsStyle={'primary'} style={{ marginRight: 10 }}>Download PDF!</Button>}
                            </>
                        );
                    }
                }
            </PDFDownloadLink>
        }
    </>
    );
}

export default LetterGenerator;